import { useContext } from "react";
import ThemeContext from "../../lib/theme-context";

const StatsCalendarDayCell = ({ dayNumber, stats, isToday, isCurrentMonth }) => {
  const theme = useContext(ThemeContext);
  const isDark = theme[0] === "dark";

  const getCellBackgroundColor = () => {
    if (!isCurrentMonth) {
      return isDark ? "#0f1012" : "#f3f4f6";
    }
    
    if (stats.tradeCount === 0) {
      return isDark ? "#1a1b1e" : "#ffffff";
    }

    if (stats.grossPnL > 0) {
      return isDark ? "rgba(16, 185, 129, 0.15)" : "rgba(16, 185, 129, 0.1)";
    } else if (stats.grossPnL < 0) {
      return isDark ? "rgba(239, 68, 68, 0.15)" : "rgba(239, 68, 68, 0.1)";
    } else {
      return isDark ? "#1a1b1e" : "#ffffff";
    }
  };

  const getPnLColor = () => {
    if (stats.grossPnL > 0) {
      return "#26a65d";
    } else if (stats.grossPnL < 0) {
      return "#f23645";
    } else {
      return "#ED9E0E";
    }
  };

  const formatCurrency = (value) => {
    const absValue = Math.abs(value);
    if (absValue >= 1000) {
      return `${value >= 0 ? "+" : "-"}$${(absValue / 1000).toFixed(2)}K`;
    }
    return `${value >= 0 ? "+" : ""}$${value.toFixed(2)}`;
  };

  const formatPercent = (value) => {
    return `${value >= 0 ? "+" : ""}${value.toFixed(2)}%`;
  };

  return (
    <div
      style={{
        backgroundColor: getCellBackgroundColor(),
        border: `1px solid ${isDark ? "#2d2e33" : "#e5e7eb"}`,
        borderTop: isToday ? `3px solid #3788d8` : undefined,
        height: "140px",
        padding: "8px",
        display: "flex",
        flexDirection: "column",
        position: "relative",
        transition: "all 0.2s ease",
        cursor: stats.tradeCount > 0 ? "pointer" : "default",
        opacity: isCurrentMonth ? 1 : 0.4,
      }}
      className="stats-day-cell"
    >
      <div
        style={{
          fontSize: "14px",
          fontWeight: isToday ? "700" : "600",
          color: isToday
            ? "#3788d8"
            : isDark
              ? "#e5e7eb"
              : "#374151",
          marginBottom: "8px",
        }}
      >
        {dayNumber}
      </div>

      {stats.tradeCount > 0 ? (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "6px",
            flex: 1,
          }}
        >
          <div
            style={{
              fontSize: "18px",
              fontWeight: "700",
              color: getPnLColor(),
              lineHeight: "1.2",
            }}
          >
            {formatPercent(stats.percentReturn)}
          </div>

          <div
            style={{
              fontSize: "13px",
              fontWeight: "600",
              color: getPnLColor(),
              lineHeight: "1.2",
            }}
          >
            {formatCurrency(stats.grossPnL)}
          </div>

          <div
            style={{
              fontSize: "12px",
              color: isDark ? "#9ca3af" : "#6b7280",
              lineHeight: "1.2",
            }}
          >
            {stats.winRate.toFixed(1)}% WR
          </div>

          <div
            style={{
              fontSize: "11px",
              color: isDark ? "#6b7280" : "#9ca3af",
              marginTop: "auto",
              lineHeight: "1.2",
            }}
          >
            {stats.tradeCount} {stats.tradeCount === 1 ? "trade" : "trades"}
          </div>
        </div>
      ) : (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flex: 1,
            fontSize: "12px",
            color: isDark ? "#4b5563" : "#d1d5db",
          }}
        >
          {isCurrentMonth ? "No trades" : ""}
        </div>
      )}
    </div>
  );
};

export default StatsCalendarDayCell;
